import validate from '../../Validate/Validate';

export default interface IPeerRecovery {
	get(): Promise<IPeerRecoveryConfiguration>;
	set(configuration: IPeerRecoveryConfiguration): Promise<void>;
}

export type IPeerRecoveryConfiguration = { enabled: false; autoEnableTimeoutMs?: number } | { enabled: true; urlLauncherAddress: string };

export const validatePeerRecoveryConfiguration = (configuration: IPeerRecoveryConfiguration) => {
	const validation = validate({ configuration }).setError(new Error('Invalid peer recovery configuration')).required();

	if (!configuration.enabled) {
		validation.object({ enabled: 'boolean', autoEnableTimeoutMs: '?number' });
	} else {
		validation.object({ enabled: 'boolean', urlLauncherAddress: 'string' });
	}
};
